import React from 'react';
import { Utensils, Home, Cake } from 'lucide-react';
export function SocialProofSection() {
  const scenarios = [{
    icon: <Utensils className="w-8 h-8 text-gold" data-id="element-553" />,
    title: 'En un restaurante',
    desc: 'Aprendé a leer el menú estratégicamente. Sabrás qué pedir para disfrutar sin que tu vientre se inflame a los 20 minutos. Resultado: salís a cenar con tu pareja y llegás a casa sintiéndote liviana.'
  }, {
    icon: <Home className="w-8 h-8 text-gold" data-id="element-554" />,
    title: 'Casa de tu suegra',
    desc: 'Técnicas sutiles para comer lo que te sirven sin romper el plan, usando el orden de los alimentos a tu favor. Resultado: disfrutás la reunión familiar sin el "después me arrepiento".'
  }, {
    icon: <Cake className="w-8 h-8 text-gold" data-id="element-555" />,
    title: 'Cumpleaños o eventos',
    desc: 'El protocolo exacto para antes y después del evento que amortigua el impacto del azúcar y el alcohol en tu intestino. Resultado: brindás, comés torta y al día siguiente tu vientre sigue plano.'
  }];
  return <section className="py-5 bg-transparent" data-id="element-556">
      <div className="container mx-auto px-4 sm:px-6 lg:px-8" data-id="element-557">
        <div className="max-w-6xl mx-auto" data-id="element-558">
          <div className="text-center mb-8" data-id="element-559">
            <h2 className="text-3xl md:text-5xl font-serif font-bold text-black mb-4" data-id="element-560">
              El Protocolo no vive en una burbuja. Vive en tu vida real.
            </h2>
            <p className="text-lg text-sage/80 max-w-2xl mx-auto" data-id="element-561">
              Estas son las 3 situaciones donde las dietas normales fallan. Y
              cómo el Protocolo Reset las resuelve:
            </p>
          </div>

          <div className="grid md:grid-cols-3 gap-6" data-id="element-562">
            {scenarios.map((scenario, idx) => <div key={idx} className="bg-white rounded-2xl p-6 shadow-md border border-sage/5 hover:shadow-xl transition-shadow duration-300" data-id="element-563">
                <div className="bg-cream w-12 h-12 rounded-full flex items-center justify-center mb-3" data-id="element-564">
                  {scenario.icon}
                </div>
                <h3 className="text-lg font-serif font-bold text-sage mb-2" data-id="element-565">
                  {scenario.title}
                </h3>
                <p className="text-sage/70 leading-snug text-sm" data-id="element-566">
                  {scenario.desc}
                </p>
              </div>)}
          </div>
        </div>
      </div>
    </section>;
}